module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-Ad-U_1.dd09eb1c.jpg";